export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/OM-bb327fa8807e12d0693363a9aae5d3f5.png";